const STYLE_PROPS = {
  disabled: 'disabled',
  dissabled: 'dissabled',
  small: 'small',
  smaller: 'smaller',
  extraRounded: 'extra-rounded',
  transparent: 'transparent',
  underlined: 'underlined',
  light: 'light',
  lightColor: 'light-color',
  regular: 'regular',
  squished: 'squished',
  plain: 'plain',
  required: 'required',
  centered: 'mx-auto',
  lineThrough: 'line-through'
}

export default {
  methods: {
    /**
     * Gives input's error styles
     * @param {Object} errorParams
     * @returns {String}
     */
    errorStyle (errorParams = {}) {
      if (errorParams.showErrorOutline) return 'error-outline'
      return ''
    },

    /**
     * Sends update ()
     */
    sendUpdate (eventName = 'fieldUpdate') {
      this.$emit(eventName, {
        extra: this.getSideValue,
        value: this.getInputValue,
        input: this.getInputName
      })

      if (this.clearAfter) {
        // Parent's function
        this.clearValue()
      }
    },

    /**
     * Gives input value directly from input is telf
     * @returns {*}
     */
    getValueFromInput () {
      return this.getInputReference.value
    }
  },

  computed: {
    /**
     * Tells if given input is required or not
     * @returns {Boolean}
     */
    required () {
      return !!this.getConstraints.required
    },

    /**
     * Gives placeholder's label
     * @returns {String}
     */
    getPlaceholderLabel () {
      return `${this.inputPlaceholder}${this.required ? ' *' : ''}`
    },

    /**
     * Gives input's inner style - the input box it self
     * @returns {String}
     */
    getInnerStyle () {
      let base = ``
      switch (this.variant) {
        case 'standardInput':
          if (this.isButton) base = 'standard-button'
          else base = 'standard-inner-input-style'
          break

        case 'plainText':
          base += ' plain-text'
          break
      }

      if (!this.isButton) {
        base += ' content-bold'
      }

      for (let sp in STYLE_PROPS) {
        if (this.$props[sp]) {
          base += ` ${STYLE_PROPS[sp]}`
        }
      }

      return base.trim()
    },

    /**
     * Gives input's constraints
     * @returns {Object}
     */
    getConstraints () {
      return this.constraints
    },

    /**
     * Gives input's side value
     * @returns {*}
     */
    getSideValue () {
      return this.sideValue
    },

    /**
     * Gives input's name
     * @returns {String}
     */
    getInputName () {
      return this.inputName
    },

    /**
     * Gives input's reference
     * @returns {Object}
     */
    getInputReference () {
      return this.$refs[this.getInputName] || {}
    },

    /**
     * Gives input's footnote
     * @returns {String}
     */
    getFootnote () {
      return this.footnote
    }
  },

  props: {
    clearAfter: {
      type: Boolean,
      required: false,
      default: false
    },
    sideValue: {
      required: false,
      default: () => { return {} }
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    identification: {
      type: String,
      required: false
    },
    inputName: {
      type: String,
      required: true,
      default: 'input'
    },
    inputValue: {
      required: false
    },
    inputPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    inputLabel: {
      type: String,
      required: false,
      default: ''
    },
    footnote: {
      type: String,
      required: false,
      default: ''
    },
    constraints: {
      required: false,
      default: false,
    },
    dissabled: {
      type: Boolean,
      required: false,
      default: false
    },

    // Styling
    variant: {
      type: String,
      required: false,
      default: 'standardInput'
    },
    fluid: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    centered: {
      type: Boolean,
      required: false,
      default: false
    },
    lineThrough: {
      type: Boolean,
      required: false,
      default: false
    },
    iconRight: {
      type: String,
      required: false,
      default: null
    },
    iconLeft: {
      type: String,
      required: false,
      default: null
    },
    stretched: {
      type: Boolean,
      required: false,
      default: false
    },
    noLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    extraRounded: {
      type: Boolean,
      required: false,
      default: false
    },
    overlap: {
      type: Boolean,
      required: false,
      default: false
    },
    squished: {
      type: Boolean,
      required: false,
      default: false
    },
    plain: {
      type: Boolean,
      required: false,
      default: false
    },
    light: {
      type: Boolean,
      required: false,
      default: false
    },
    lightColor: {
      type: Boolean,
      required: false,
      default: false
    },
    regular: {
      type: Boolean,
      required: false,
      default: false
    },
    smaller: {
      type: Boolean,
      required: false,
      default: false
    },
    slimmer: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    transparent: {
      type: Boolean,
      required: false,
      default: false
    },
    underlined: {
      type: Boolean,
      required: false,
      default: false
    },
    clear: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/components/standard/input/inputButton/stylers.js